{
  "produktionen": [
    {
      "id": 1,
      "slug": "juedischer-friedhof-greifswald",
      "titel": "Der jüdische Friedhof Greifswald",
      "vorschaubild": "img/filmproduktionen/friedhof-greifswald-thumb.webp",
      "video_src": "videos/filmproduktionen/friedhof-greifswald.mp4",
      "video_poster": "img/filmproduktionen/friedhof-greifswald-poster.webp",
      "beschreibung": "Dieses Video dokumentiert den jüdischen Friedhof Greifswald in seinem aktuellen Zustand und zeigt Bemühungen den Ort sichtbarer zu machen.",
      "dauer": "4:16"
    },
    {
      "id": 2,
      "slug": "juedischer-friedhof-niederhof",
      "titel": "Der jüdische Friedhof Niederhof",
      "vorschaubild": "img/filmproduktionen/friedhof-niederhof-thumb.webp",
      "video_src": "videos/filmproduktionen/friedhof-niederhof.mp4",
      "video_poster": "img/filmproduktionen/friedhof-niederhof-poster.webp",
      "beschreibung": "Ein Besuch mit Schüler:innen der IGS „Erwin Fischer“ auf dem jüdischen Friedhof Niederhof, dessen Grabsteine den historischen Ort bis heute erkennbar machen.",
      "dauer": "4:00"
    },
    {
      "id": 3,
      "slug": "juedisches-leben-stralsund",
      "titel": "Jüdisches Leben in Stralsund",
      "vorschaubild": "img/filmproduktionen/stralsund-thumb.webp",
      "video_src": "videos/filmproduktionen/stralsund.mp4",
      "video_poster": "img/filmproduktionen/stralsund-poster.webp",
      "beschreibung": "Ein Stadtrundgang mit Jörg Zink mit Blick auf die Erinnerungskultur der Stadt Stralsund.",
      "dauer": "2:46"
    },
    {
      "id": 4,
      "slug": "yuriy-kadnykov",
      "titel": "Landesrabbiner Yuriy Kadnykov",
      "vorschaubild": "img/filmproduktionen/yuriy-kadnykov-thumb.webp",
      "video_src": "videos/filmproduktionen/yuriy-kadnykov.mp4",
      "video_poster": "img/filmproduktionen/yuriy-kadnykov-poster.webp",
      "beschreibung": "Landesrabbiner Yuriy Kadnykov besuchte das Projekt und gab den Schülerinnen und Schülern die Möglichkeit Fragen über das Judentum und das Leben als Rabbiner zu stellen.",
      "dauer": "4:52"
    }
  ]
}
